
export default {

    /**
     * Nombre del componente
     */
    name: 'YuriText',

    /**
     * Propiedades de entrada
     * text: texto a mostrar en el botón
     * type: tipo de botón (submit/cancel)
     */
    props: {
        text: {
            type: String | Number,
            required: false
        },
        fontSize: {
            type: Number,
            required: false,
            default: 16
        },
        bold: {
            type: Boolean,
            required: false,
            default: false
        },
        italic: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: false,
            default: 'grey'
        },
        ellipsis: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    /**
     * @override
     */
    data() {
        return {
            styleObject: {}
        };
    },

    /**
     * @override
     */
    created() {
        if (this.fontSize) {
            this.styleObject.fontSize = `${this.fontSize}px`;
        }
        if (this.bold) {
            this.styleObject.fontWeight = `bold`;
        }
        if (this.italic) {
            this.styleObject.fontStyle = `italic`;
        }
    }
};
